import { Injectable } from "@angular/core";
import { FirestoreV9Service } from "../../services";
import { JTMSMetadata, JTMSJobsMetadata } from "@dis/models";
import { DocumentData, FirestoreDataConverter } from "firebase/firestore";
import { Observable } from "rxjs";

@Injectable({
  providedIn: "root",
})
export class JTMSMetadataCollection extends FirestoreV9Service<JTMSMetadata> {
  protected override basePath = "jtmsMetadata";
  protected override baseConverter!: FirestoreDataConverter<JTMSMetadata, DocumentData>;

  jobs$ = this.doc$("jobs") as unknown as Observable<JTMSJobsMetadata>;
}
